import { get, post } from '@/apis/http';
import { apiPath } from '@/config';

/** 回归活动 **/

//报名回归活动
export function postSignActivityhg(data) {
    return post(apiPath + '/uc/Activityhg/sign', data)
}

//回归活动用户信息
export function queryHgActivityUserInfo(data) {
    return post(apiPath + '/uc/Activityhg/getHgActivityUserInfo', data)
}
// 春节摇一摇活动
// 兑换转盘次数
export function exchangeNumNew(data) {
    return get(apiPath + '/uc/userPoint/exchangeTurntableNumNew?stcid=' + data)
}

// 获取转盘次数

export function getexchangeNum(data) {
    return get(apiPath + '/uc/userPoint/getexchangeTurntableNum?stcid=' + data)
}